module.exports = __webpack_public_path__ + "img/loan-landing.06a3233a.svg";